document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.product-recommendations[data-url]');
  if (!container) {
    console.warn('Product recommendations container not found');
    return;
  }

  const url = container.dataset.url;
  if (!url) {
    console.warn('No URL found in data-url attribute');
    return;
  }

  // Wait for Swiper and custom element to be available
  function waitForDependencies(callback) {
    if (typeof Swiper !== 'undefined' && customElements.get('lsg-slider')) {
      callback();
    } else {
      setTimeout(() => waitForDependencies(callback), 50);
    }
  }

  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(html => {
      if (!html || html.trim() === '') {
        return;
      }

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const section = temp.querySelector('[id^="shopify-section-"]');
      
      if (section) {
        container.innerHTML = section.innerHTML;

        // Wait for dependencies before initializing
        waitForDependencies(() => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              const sliders = container.querySelectorAll('lsg-slider');

              sliders.forEach(slider => {
                if (slider.reInit && typeof slider.reInit === 'function') {
                  slider.reInit();
                } else {
                  // Dispatch custom event to trigger initialization
                  slider.dispatchEvent(new CustomEvent('lsg:slider:reinit'));
                }
              });
            }, 100);
          });
        });
      } else {
      }
    })
    .catch(err => {
      console.error('Recommendations error:', err);
    });
});